import { PlacesCounter } from "@/components/site/PlacesCounter";

export const MobileBar = ({ camp, onRegister }) => (
  <div data-testid="mobile-sticky-bar" className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-[#070a11]/90 backdrop-blur-xl border-t border-white/10 px-5 py-3 flex items-center justify-between gap-4">
    <div>
      <p className="font-display font-bold text-sm">$549 · 12–20 Dec</p>
      <div className="text-[11px] text-slate-400">9 days · Adelaide · inc. GST<PlacesCounter camp={camp} inline /></div>
    </div>
    <button onClick={onRegister} className="btn-primary !py-3 !px-5" data-testid="mobile-register-button">Book Now</button>
  </div>
);
